/**
 * UserService.ts
 * ------------------------------------------------------------
= * 1.  Se crea una instancia de Axios (`api`) con `baseURL`
 *     y `withCredentials: true` por defecto ⟶ la cookie
 *     del backend viajará sin repetir la opción en cada llamada.
 * 2.  Se tipan las respuestas (`LoginResponse`, `AuthResponse`)
 *     para ganar autocompletado y validar la forma del JSON.
 * 3.  Manejo de errores uniforme: siempre se devuelve `boolean`
 *     o `null`, nunca se propaga la excepción al componente.
 * ------------------------------------------------------------
 */

import axios from "axios";
import { HOST } from "./constants";

const api = axios.create({
  baseURL: HOST + "/catalogmx/index.php",
  withCredentials: true,
});

interface AuthResponse {
  auth: boolean;
  user: {
    id: number;
    username: string;
    nombre: string;
  };
}

// ---------- Login ----------
export const handleUserLogin = async (
  username: string,
  pass: string
): Promise<boolean> => await axios({
  method: 'post',
  url: HOST + '/catalogmx/index.php/user/login',
  data: {
    username,
    key: btoa(pass),             // el backend lo decodifica
  }
}).then(
  response => { return response.data }
).catch(error => {
  console.log(error)
  return false;
});

// ---------- Verificar sesión ----------
export const checkUserSession = async (): Promise<
  { id: number; username: string; nombre: string } | null
> => {
  try {
    const { data } = await api.get<AuthResponse>("/user/auth");
    return data.auth ? data.user : null;
  } catch (err) {
    console.error("❌ Error validar sesión:", err);
    return null;
  }
};

export const getAllUsers = async () => await axios.get(HOST + '/catalogmx/index.php/user/list')
  .then(response => response.data)
  .catch(error => {
    console.error(error);
  })


export const createUser = async (data: { username: string; name: string; key: string }) => await axios({
  method: 'post',
  url: HOST + '/catalogmx/index.php/user/create',
  data: data
}).then(response => response.data)
  .catch(error => console.error(error))

export const updateUser = async (data: { id: number; username: string; name: string; key?: string; activo: boolean }) => await axios({
  method: 'put',
  url: HOST + '/catalogmx/index.php/user/update',
  data: data
}).then(response => {
  return response.data;
}).catch(error => console.error(error))
